import React, {useEffect} from "react";
import { useTranslation } from "react-i18next";
import { withFormik } from 'formik';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import Validations from 'utils/Validations';
import store from 'redux/store';
import { sendFormDataHandler } from 'redux/forms/actions';
import { Button, Input } from 'components/commons'
import {createSelector} from "reselect";
import {useAppSelector} from "../../redux/hooks";

const memoizedSelector = createSelector(
    state => state.users.currentUser.userLoaded,
    state => state.users.currentUser.data,
    state => state.sellers.currentSeller.info.data?.id,
    (currentUserLoaded, currentUserData, sellerId) => ({ currentUserLoaded, currentUserData, sellerId})
);

function FormResolvingFunds(props) {
  const {
    values,
    touched,
    errors,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    setModalOpen,
    setFieldValue
  } = props;

  const { t } = useTranslation();

  const { currentUserLoaded, currentUserData, sellerId } = useAppSelector(memoizedSelector)

  useEffect(() => {
    values.seller = sellerId;
    if (currentUserLoaded) {
      values.email = currentUserData.email;
    }

  }, [sellerId, currentUserLoaded, currentUserData])

  const closeForm = (e) => {
    e.stopPropagation();
    setModalOpen(false);
  }

  React.useEffect(() => {
    if (isSubmitting) {
      setTimeout(() => {
        setModalOpen(false)
      }, 3000)
    }
  }, [isSubmitting])

  return (
    <>
      <form action="" id='bankForm' onSubmit={handleSubmit}>
        <div className="px-5 py-4">
          <div className="space-y-3">
            <div>
              <Input
                placeholder="Ivan"
                id="name"
                name="name"
                value={values.name}
                label={t("name_username", { ns: "messages" })}
                changeHandler={handleChange}
                customLabelClassName="text-sm"
                blurHandler={handleBlur}
                validationError={errors && errors.name && touched.name && errors.name.length > 0}
                validationErrorDescription={errors.name && touched.name && errors.name}
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1 text-gray-600 text-left" htmlFor="phone">{t("phone_number", { ns: "messages" })} <span className="text-red-500">*</span></label>
              <PhoneInput
                inputStyle={{ border: "1px solid", borderColor: "rgba(226, 232, 240, var(--tw-border-opacity))", width: "100%", color: "#000000" }}
                buttonStyle={{ border: "1px solid", borderColor: "rgba(226, 232, 240, var(--tw-border-opacity))" }}
                regions={['north-america', 'europe']}
                country={"ru"}
                onBlur={handleBlur}
                preferredCountries={['ru', 'ua', 'by']}
                placeholder="+7 (999) 999-99-99"
                value={values.phone}
                prefix={"+"}
                onChange={e => {
                  if (e.replace(/\D/g, '').length === 2) {
                    setFieldValue('phone', e.replace('8', ''));
                  } else {
                    setFieldValue("phone", e)
                  }
                }}
                id="phone"
                required />
              {errors.phone && touched.phone && (<div className="text-xs text-left mt-2 text-red-500 input-feedback">{errors.phone}</div>)}
            </div>
            <div>
              <Input
                placeholder={t("itn_ev", { ns: "messages" })}
                id="itn"
                name="itn"
                value={values.itn}
                label={t("itn_ev", { ns: "messages" })}
                changeHandler={handleChange}
                customLabelClassName="text-sm"
                blurHandler={handleBlur}
                validationError={errors && errors.itn && touched.itn && errors.itn.length > 0}
                validationErrorDescription={errors.itn && touched.itn && errors.itn}
              />
            </div>
          </div>
        </div>
        {/* Modal footer */}
        <div className="px-5 py-4 border-t border-gray-200">
          <div className="flex flex-wrap justify-end space-x-2 mt-4">
            <Button type="button" size="sm" appearance="tertiary" clickHandler={closeForm}>{t("Close", { ns: "messages" })}</Button>
            <Button loading={isSubmitting} type="submit" appearance="primary" size="sm">{t("Send", { ns: "messages" })}</Button>
          </div>
        </div>
      </form>
    </>
  )
}

const MyEnhancedForm = withFormik({
  mapPropsToValues: () => ({ name: '', phone: '', itn: '', email: '', seller: null }),

  validate: values => {
    let errors = {};

    const validation = Validations()

    Object.keys(values).forEach((key) => validation[key] && validation[key](errors, values[key]))

    return errors;
  },

  handleSubmit: (values, { setSubmitting }) => {
    setTimeout(() => {
      setSubmitting(false);
      store.dispatch(sendFormDataHandler({
        data: values
      }))
    }, 3000);
  },

  displayName: 'FormResolvingFunds',
})(FormResolvingFunds);


export default MyEnhancedForm;